<template>
  <div id="accountHistory" class="modal fade" role="dialog">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header endtour-chkbox">
          <p class="title tex-emergo-dark-blue">Records</p>
          <img
            src="/static/images/icons/close_icon.svg"
            class="close-icon cursor-pointer"
            data-dismiss="modal"
            alt="close-icon"
          />
        </div>
        <div class="modal-body">
          <div v-for="(account, index) in accountList" :key="index">
            <div
              class="row pb-25 m-0 border-bottom"
              :class="{ 'pt-25': index !== 0, 'border-bottom': index !== accountList.length - 1 }"
            >
              <div class="col-xs-8 p-0">
                <p class="header">Account name</p>
                <p class="name">{{ account.updated_account_name }}</p>
              </div>
              <div class="col-xs-4 align-right p-0">
                <p class="header">Updated on</p>
                <p class="name">{{ timeFormat(account.updated_at) }}</p>
              </div>
            </div>
          </div>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import { getAccountHistoryInfo } from '../../apis/accountDetails';

export default {
  data() {
    return {
      accountList: [],
      loaderStatus: false
    };
  },
  props: ['accountId'],
  components: { Loader },
  methods: {
    timeFormat(date) {
      return moment(date).format('MMM DD, YYYY');
    },
    async getAccountHistoryInfo() {
      this.loaderStatus = true;
      this.accountList = await getAccountHistoryInfo(this.accountId);
      this.loaderStatus = false;
    }
  },
  mounted() {
    $('#accountHistory').on('shown.bs.modal', async () => {
      await this.getAccountHistoryInfo();
    });
  }
};
</script>
<style scoped>
.modal .modal-content {
  font-family: Roboto;
  font-style: normal;
}
.modal .modal-header {
  background: none;
  border: none;
  position: relative;
  padding: 24px 20px 15px 24px;
}
.modal .modal-header .close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
}
.modal-header .title {
  font-weight: 300;
  font-size: 28px;
  line-height: 33px;
}
.modal .modal-body {
  padding: 0px 14px;
  margin: 0px 10px;
  max-height: 500px;
  overflow-y: overlay;
}
.modal-body .name {
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 300;
}
.modal-body .header {
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 15px;
}
.pt-25 {
  padding-top: 25px;
}
.pb-25 {
  padding-bottom: 15px;
}
.border-bottom {
  border-bottom: 1px solid #828282;
}
@media screen and (max-width: 767px) {
  .align-right {
    text-align: left;
  }
  .modal-dialog {
    width: 90%;
  }
}
</style>
